define("powergen/components/x-improvement-overlay",
  [],
  function() {
    "use strict";
    var XImprovementOverlayComponent;

    XImprovementOverlayComponent = Ember.Component.extend({
      tagName: 'div',
      classNames: ['overlay', 'improvement-overlay'],
      classNameBindings: ['improvement.part.type.id', 'show'],
      attributeBindings: ['style'],
      actions: {
        close: function() {
          this.set('show', false);
          return this.sendAction('selectPartForImprovement', {
            improvement: this.get('improvement'),
            part: this.get('selectedPart')
          });
        },
        selectPart: function(partWrapper) {
          this.get('improvement.partList').setEach('selected', false);
          partWrapper.set('selected', true);
          return this.set('selectedPart', partWrapper.get('part'));
        }
      },
      style: (function() {
        var containerTop, containerWidth, left, top;
        containerTop = this.get('containerTop');
        containerWidth = this.get('containerWidth');
        top = this.get('improvement.position.y') - this.get('height');
        if (top < 0 && top + containerTop < 0) {
          top += Math.abs(top + containerTop);
        }
        left = this.get('improvement.position.x') - ((this.get('width') / 2) - (this.get('improvement.size.width') / 2)) + 7;
        if (left + this.get('width') > containerWidth) {
          left = Math.abs(containerWidth - this.get('width'));
        }
        return this.get('util').styleString({
          'width': '%@px'.fmt(this.get('width')),
          'height': '%@px'.fmt(this.get('height')),
          'left': '%@px'.fmt(left),
          'top': '%@px'.fmt(top),
          'margin-top': '10px'
        });
      }).property('improvement.id', 'containerTop', 'containerWidth'),
      show: false,
      width: 563,
      height: 630,
      containerTop: 0,
      containerWidth: 0,
      selectedPart: null,
      didInsertElement: function() {
        this.set('containerWidth', $('.improvements').first().width());
        return this.set('containerTop', $('.improvements').first().offset().top);
      }
    });


    return XImprovementOverlayComponent;
  });